import { PolicyComponentsState } from "@idw-types/state/policy-components-state";
import { getPolicyComponentsState } from "@redux/selectors/root-selectors";
import { createSelector } from "reselect";

export const getPolicyComponentsDataState = createSelector(getPolicyComponentsState, (state: PolicyComponentsState) => {
    return {
        isLoadingPolicyComponents: state.policyComponents.isLoading,
        policyComponents: state.policyComponents.policyComponents
    }
});